import React, { useState, useCallback, useEffect } from "react";
import images from "../../../constant/images";
import { Nav } from "../../../layouts/navbar/nav";
import Sidebar from "../../../layouts/sidebar/sidebar";
import { MdInsertPhoto } from "react-icons/md";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import { storePicture, storeProfile, updateUser } from "../../../formSlice";
import imageCompression from "browser-image-compression";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
// import { translate } from "../localization";

export default function Profile() {
  const { i18n, t } = useTranslation();
  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
  };
  const [isLoading, setIsLoading] = useState(true);
  const baseUrl = useSelector((state) => state.gtm.baseUrl);
  const [hideToast, setHideToast] = useState(true);
  const [user, setUser] = useState();
  const [pack, setPack] = useState(null);
  const [isEnabled, setIsEnabled] = useState(false);
  const [picture, setPicture] = useState(null);
  const [upload, setUpload] = useState(false);
  const [uploadErr, setUploadErr] = useState("");
  const [isChecked, setChecked] = useState(false);
  const [editable, setEditable] = useState(true);
  const [enabled, setEnabled] = useState(true);
  const [updatingImage, setUpdatingImage] = useState(false);

  // form data states
  const [email, setEmail] = useState("");
  const [sex, setSex] = useState(null);
  const [fname, setFname] = useState("");
  const [lname, setLname] = useState("");
  const [password, setPassword] = useState("");
  const [country, setCountry] = useState(null);
  const [countryCode, setCountryCode] = useState(null);
  const [city, setCity] = useState(null);
  const [phoneNumber, setPhoneNumber] = useState(null);
  const [phoneMessage, setPhoneMessage] = useState(null);
  const [countryPhoneCode, setCountryPhoneCode] = useState("MA");
  const [callingCode, setCallingCode] = useState("212");
  const [age, setAge] = useState("25-49");
  const [golfer, setGolfer] = useState("Yes");
  const [handicap, setHandicap] = useState(null);
  const [license, setLicense] = useState(null);
  const [sector, setSector] = useState(null);
  const [specify, setSpecify] = useState(null);
  const [specifyMessage, setSpecifyMessage] = useState(null);
  const [company, setCompany] = useState(null);
  const [position, setPosition] = useState(null);
  const [dateOfBirth, setDateOfBirth] = useState(null);
  const [dateValidated, setDateValidated] = useState(false);
  const [dateOfBirthMessage, setDateOfBirthMessage] = useState(null);
  const [date, setDate] = useState(new Date());
  const [showPicker, setShowPicker] = useState(false);
  const [club, setClub] = useState(null);
  const [referred, setReferred] = useState(null);
  const [withFlag, setWithFlag] = useState(true);
  const [withCountryNameButton, setWithCountryNameButton] = useState(true);
  const [withFilter, setWithFilter] = useState(true);
  const [hidePass, setHidePass] = useState(true);
  const [passwordMessage, setPasswordMessage] = useState("");
  const [emailMessage, setEmailMessage] = useState("");
  const [emailValidated, setEmailValidated] = useState(true);
  const [passwordValidated, setPasswordValidated] = useState(true);
  const [reload, setReload] = useState("");
  const dispatch = useDispatch();
  const profile = useSelector((state) => state.gtm.form.picture);
  const [file, setFile] = useState(null);
  const [IsPicked, setIsPicked] = useState(false);
  const [modalVisible, setModalVisible] = useState(false);
  const [membership, setMembership] = useState(null);
  const [picturePreview, setPicturePreview] = useState("");
  const [refresh, setRefresh] = useState(false);

  const navigate = useNavigate();

  const moroccanCities = [
    "Casablanca",
    "Rabat",
    "Marrakech",
    "Fez",
    "Tangier",
    "Agadir",
    "Oujda",
    "Meknes",
    "Tetouan",
    "Other",
  ];
  const ageItems = ["25-49", "50+"];

  const handicapItems = ["0-8", "9-18", "19-25", "25+"];

  const sectorItems = ["Finance", "Technology", "Healthcare", "Other"];

  const Golfer = ["Yes", "No"];

  // date picker
  const toggleDatePicker = () => {
    setShowPicker(!showPicker);

  };

  const onChange = ({ type }, selectedDate) => {
    if (type == "set") {
      const birthDate = new Date(selectedDate);
      const today = new Date();
      let age = today.getFullYear() - birthDate.getFullYear();
      // Check if the birthday has occurred this year
      const monthDiff = today.getMonth() - birthDate.getMonth();
      const dayDiff = today.getDate() - birthDate.getDate();

      if (monthDiff < 0 || (monthDiff === 0 && dayDiff < 0)) {
        age--; // Reduce age if the birthday hasn't passed yet this year
      }

      if (age < 25) {
        setDateOfBirthMessage(
          "Users under 25 years old cannot complete registration."
        );
        setDateValidated(false);
      } else {
        setDateValidated(true);
        setDateOfBirthMessage(null);
      }


      const currentDate = selectedDate;
      

      setDate(currentDate);
      setDateOfBirth(
        currentDate.toLocaleDateString("en-GB", {
          year: "numeric",
          month: "2-digit",
          day: "2-digit",
        })
      );
    } else {
      toggleDatePicker();
    }
  };

  // fetch the user when the screen renders && set the pack if the membership is fetched.
  useEffect(() => {
    const fetchUser = async () => {
      setIsLoading(true);
      const token = localStorage.getItem("userToken");

      try {
        if (token) {
          const response = await axios.get(`${baseUrl}/user`, {
            headers: { Authorization: `Bearer ${token}` },
          });

          //setting the states from the response
          setCountry(response.data.pays);
          setSex(response.data.sexe);
          setLname(response.data.nom);
          setFname(response.data.prenom);
          setCountryCode(response.data.country_code);
          setCountryPhoneCode(response.data.phone_code);
          setCallingCode(response.data.calling_code);
          setPhoneNumber(response.data.telephone);
          setCity(response.data.ville);
          setAge(response.data.age);
          setEmail(response.data.email);
          setGolfer(response.data.golfeurs);
          setPosition(response.data.poste);
          setLicense(response.data.licence_numero);
          setClub(response.data.club);
          setCompany(response.data.entreprise);
          setReferred(response.data.referred_by);
          setDateOfBirth(response.data.date_naissance);

          if (
            response.data.golfeurs == "Yes" ||
            response.data.golfeurs == "Oui"
          ) {
            setEditable(true);
            setEnabled(true);
          } else {
            setEditable(false);
            setEnabled(false);
          }

          setSector(response.data["secteur_d'activite"]);
          setUser(response.data);
          setMembership(response.data?.membership);

          if (response.data.membership) {
            setIsEnabled(response.data.membership?.visibility || false);
            if (response.data?.membership?.status.trim() === "valid") {
              setPack(response.data.membership?.membership_packs);
            }
          }

          const [day, month, year] = response.data.date_naissance.split("/");
          const birthDate = new Date(year, month - 1, day);


          const today = new Date();
          let age = today.getFullYear() - birthDate.getFullYear();
          // Check if the birthday has occurred this year
          const monthDiff = today.getMonth() - birthDate.getMonth();
          const dayDiff = today.getDate() - birthDate.getDate();

          if (monthDiff < 0 || (monthDiff === 0 && dayDiff < 0)) {
            age--; // Reduce age if the birthday hasn't passed yet this year
          }

          if (age < 25) {
            setDateOfBirthMessage(
              "Users under 25 years old cannot complete registration."
            );
            setDateValidated(false);
          } else {
            setDateValidated(true);

            setDateOfBirthMessage(null);
          }
        }
      } catch (error) {

      } finally {
        setIsLoading(false);
      }
    };

    fetchUser();

    return () => {
      setUser(null);
      setUploadErr(null);
    };
  }, []);

  // update the member's visibility when the switch gets toggled

  const toggleSwitch = async () => {
    const newState = !isEnabled;
    setIsEnabled(newState);

    try {
      await axios.put(`${baseUrl}/members/${user?.membership?.id}`, {
        visibility: newState,
      });
    } catch (error) {

    }
  };

  const pickImage = async (e) => {
    const file = e.target.files[0];


    if (file) {
      // Create preview URL immediately
      const previewUrl = URL.createObjectURL(file);


      setPicturePreview(previewUrl);

      // Compression options
      const options = {
        maxWidthOrHeight: 800, // Maximum width or height
        useWebWorker: true, // Use web worker for better performance
        initialQuality: 0.7, // Initial quality (0.7 = 70% quality)
      };

      try {
        // Compress the image
        const compressedFile = await imageCompression(file, options);
        

        // Get file extension and type
        const ext = file.name.split(".").pop();
        const type = file.type || `image/${ext === "jpg" ? "jpeg" : ext}`; // Fallback for type

        // Create a data URL for the compressed image
        const reader = new FileReader();
        reader.onload = (event) => {
          const uri = event.target.result;

          setFile({
            uri: uri,
            name: `${user?.email}.${ext}`,
            type: type,
            file: compressedFile, // Store the compressed file for upload
          });

          setPicture(uri);
          storePicture(compressedFile);

          setIsPicked(true);

          // Clean up the preview URL after we have the compressed version
          if (previewUrl) {
            URL.revokeObjectURL(previewUrl);
          }
        };

        reader.onerror = () => {
          throw new Error("Failed to read compressed file");
        };

        reader.readAsDataURL(compressedFile);
      } catch (error) {
        console.error("Error processing image:", error);
        setUploadErr(`Failed to process image. ${error.message}`);
        // Clean up the object URL if there was an error
        if (previewUrl) URL.revokeObjectURL(previewUrl);
      }
    }
  };

  // Update the user's profile picture

  const updateImage = async () => {


    try {

      const formData = new FormData();
      formData.append("image", file.file); // Use the actual File object from your state
      formData.append("user_id", user?.id);

      // Log FormData contents properly
      for (let [key, value] of formData.entries()) {

      }

      setUpdatingImage(true);

      if (!user?.id) {
        throw new Error("User data is not valid.");
      }

      const response = await axios.post(`${baseUrl}/update-image`, formData, {
        withCredentials: true,
        withXSRFToken: true,
        credentials: "include",
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });


      dispatch(storeProfile(response.data.url));
      setPicturePreview(response.data.url);
      setRefresh(true);
    } catch (error) {
      console.error("Error in updateImage:", error);
      setUploadErr(error.response?.data?.message || "Failed to update image");
    } finally {
      setUpdatingImage(false);
      setIsPicked(false);
      setRefresh(false);
    }
  };

  useEffect(() => {


    // if (refresh) {
    //   console.log("Refreshing the page...gggggggggggg");

    //   window.location.reload();
    // }
  }, [refresh]);

  const update = async () => {



    const numbers = /^[0-9]+$/;
    if (numbers.test(phoneNumber) == false) {
      setPhoneMessage("Phone number should contain only numbers.");
      return;
    } else {
      if (sector == "Other") {
        if (!specify) {
          setSpecifyMessage("Please specify your industry.");
          return;
        }
      } else {
        if (dateValidated) {

          const response = await axios.put(
            `${baseUrl}/update-user`,
            {
              id: user?.id,
              email: email,
              password: password,
              country: country,
              city: city,
              countryCode: countryCode,
              phoneNumber: phoneNumber,
              phoneCode: countryPhoneCode,
              callingCode: callingCode,
              age: age,
              dateOfBirth: dateOfBirth,
              golfer: golfer,
              club: club,
              handicap: handicap,
              license: license,
              sector: specify ?? sector,
              company: company,
              position: position,
              referred: referred,
            },
            {
              withCredentials: true,
              withXSRFToken: true,
              credentials: "include",
            }
          );



          dispatch(updateUser(response.data.user)); // Dispatching action
          if (response.data.user) {
            setHideToast(false);
            // hide toast and reload the app after 1 seconds
            setTimeout(async () => {
              setHideToast(true);
              // window.location.reload();
            }, 1000);
          }
        }
      }
    }
  };

  const deleteUser = async () => {
    try {
      const response = await axios.delete(`${baseUrl}/delete-user/${user?.id}`);
      if (response.status == 200) {
        setHideToast(false);
        // hide toast and reload the app after 1 seconds
        setTimeout(async () => {
          setHideToast(true);
          window.location.reload();
        }, 1000);
      }
    } catch (error) {}
  };
  const getimages = (packType) => {
    if (packType) {
      return membership?.membership_packs?.profile;
    }

    if (user?.free_pack === 1) {
      return images.Frame;
    }

    return images.visiteur;
  };
  const imagess = getimages(membership?.membership_packs?.profile);

  const triggerFileInput = () => {
    document.getElementById("profileInput").click();
  };

  const getimagess2 = (packType) => {
    if (packType) {
      return `${membership?.membership_packs?.color}`;
    }

    return "#608D40";
  };
  const imagess22 = getimagess2(membership?.membership_packs?.color);

  return (
    

          <div className="bg-white bg-opacity-[87%] shadow-custom flex flex-col justify-center items-center p-6 md:p-16 gap-4 md:gap-8 w-full md:w-[100%] rounded-3xl py-8 md:py-12">
            {isLoading ? (
              <div className="flex justify-center items-center h-64">
                <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-gray-900"></div>
              </div>
            ) : (
              <div>
                <div className="text-center text-3xl md:text-4xl font-bold mb-2 md:mb-3">
                  <p> {t("profil.my_profile")}</p>
                </div>
                <div className=" text-center p-6 md:p-16 rounded-3xl w-full h-full flex flex-col gap-6 md:gap-12">
                  <div className="flex flex-col items-center justify-center">
                    {/* Image upload section */}
                    {updatingImage ? (
                      <div className="flex justify-center items-center h-[100px] w-[100px] md:h-[135px] md:w-[135px] rounded-full bg-gray-200">
                        <div className="animate-spin rounded-full h-6 w-6 md:h-8 md:w-8 border-b-2 border-gray-900"></div>
                      </div>
                    ) : (
                      <>
                        <input
                          id="profileInput"
                          type="file"
                          accept="image/*"
                          className="hidden"
                          onChange={pickImage}
                        />
                        <div
                          className="relative cursor-pointer"
                          onClick={triggerFileInput}
                        >
                          <img
                            src={imagess}
                            alt="Profile"
                            className="h-[120px] w-[200px] md:h-[140px] md:w-[235px]"
                          />
                          <img
                            src={picturePreview || user?.photo}
                            alt="Profile"
                            className="h-[120px] w-[120px] md:h-[135px] md:w-[135px] rounded-full absolute bottom-[5px] left-1/2 transform -translate-x-1/2"
                          />
                        </div>
                      </>
                    )}

                    {/* Update/Edit button */}
                    {IsPicked ? (
                      <button
                        onClick={() => updateImage()}
                        className="text-white mt-3 mb-2 font-bold px-6 py-1 md:px-8 md:py-2 rounded-full text-sm md:text-base cursor-pointer"
                        style={{
                          backgroundColor: imagess22,
                        }}
                      >
                        {t("profil.pict")}
                      </button>
                    ) : (
                      <button
                        onClick={() => {
                          if (user && user.id) {
                            triggerFileInput();
                          } else {
                            setUploadErr("Please wait for user data to load.");
                          }
                        }}
                        className="text-[#0d70a1] mt-1 font-bold px-6 py-1 md:px-8 md:py-2 text-sm md:text-base cursor-pointer"
                      >
                        {t("profil.edit")}
                      </button>
                    )}

                    {/* Error message */}
                    {uploadErr && (
                      <div className="text-red-500 text-xs md:text-sm mt-1">
                        {uploadErr}
                      </div>
                    )}

                    {/* Member status */}
                    {pack && (
                      <div className="mt-2 mb-1 text-sm md:text-base">
                        <span
                          className="font-bold"
                          style={{ color: pack?.color || "#000" }}
                        >
                          {pack?.name?.charAt(0).toUpperCase() +
                            pack?.name?.slice(1)} {t("sideBar.member")}
                        </span>
                        
                      </div>
                    )}

                    {/* Upgrade option */}
                    {pack?.id !== 3 && (
                      <button
                        onClick={() => navigate("/membership/demande")}
                        className={`font-bold px-6 py-2 md:px-8 md:py-3 rounded-full text-sm md:text-base ${
                          membership?.membership_packs?.name === "golfer" ||
                          membership?.membership_packs?.name === "golfer+"
                            ? "text-black"
                            : " text-white"
                        }`}
                        style={{
                          backgroundColor: imagess22,
                        }}
                      >
                        Upgrade
                      </button>
                    )}
                  </div>
                  <div className="grid gap-5 grid-cols-1 md:grid-cols-2">
                    {/* the right section */}
                    <div className="flex flex-col gap-3">
                      <div className="flex flex-col md:flex-row gap-4">
                        <div className="text-start flex flex-col gap-1 w-full">
                          <label className="font-semibold text-sm md:text-base">
                            {t("profil.first_name")}
                          </label>
                          <input
                            type="text"
                            value={fname}
                            onChange={(e) => setFname(e.target.value)}
                            className="bg-[#F4F5F9] border-none rounded-xl py-2 md:py-3 px-4 md:px-5 w-full placeholder-[#A4A4A4] text-sm md:text-base"
                            placeholder="Prénom"
                          />
                        </div>
                        <div className="text-start flex flex-col gap-1 w-full">
                          <label className="font-semibold text-sm md:text-base">
                            {t("profil.last_name")}
                          </label>
                          <input
                            type="text"
                            value={lname}
                            onChange={(e) => setLname(e.target.value)}
                            className="bg-[#F4F5F9] border-none rounded-xl py-2 md:py-3 px-4 md:px-5 w-full placeholder-[#A4A4A4] text-sm md:text-base"
                            placeholder="Nom de famille"
                          />
                        </div>
                      </div>
                      <div className="text-start flex flex-col gap-1">
                        <label className="font-semibold text-sm md:text-base">
                          {t("profil.password")}
                        </label>
                        <input
                          type={hidePass ? "password" : "text"}
                          value={password}
                          onChange={(e) => setPassword(e.target.value)}
                          className="bg-[#F4F5F9] border-none rounded-xl py-2 md:py-3 px-4 md:px-5 w-full placeholder-[#A4A4A4] text-sm md:text-base"
                          placeholder="Mot de passe"
                        />
                      </div>
                      <div className="text-start flex flex-col gap-1">
                        <label className="font-semibold text-sm md:text-base">
                          {t("profil.gender")}
                        </label>
                        <input
                          type="text"
                          value={sex}
                          onChange={(e) => setSex(e.target.value)}
                          className="bg-[#F4F5F9] border-none rounded-xl py-2 md:py-3 px-4 md:px-5 w-full placeholder-[#A4A4A4] text-sm md:text-base"
                          placeholder="Sexe ex: Homme"
                        />
                      </div>
                      <div className="text-start flex flex-col gap-1">
                        <label className="font-semibold text-sm md:text-base">
                          {t("profil.city")}
                        </label>
                        <select
                          value={city}
                          onChange={(e) => setCity(e.target.value)}
                          required
                          className="w-full text-gray-400 focus:text-black bg-[#F4F5F9] rounded-xl py-2 md:py-3 px-4 md:px-5 border-none text-sm md:text-base"
                        >
                          {moroccanCities?.map((item) => (
                            <option key={item} value={item}>
                              {item}
                            </option>
                          ))}
                        </select>
                      </div>
                      <div className="flex flex-col md:flex-row gap-4">
                        <div className="text-start flex flex-col gap-1 w-full">
                          <label className="font-semibold text-sm md:text-base">
                            {t("profil.age")}
                          </label>
                          <select
                            value={age}
                            onChange={(e) => setAge(e.target.value)}
                            required
                            className="w-full text-gray-400 focus:text-black bg-[#F4F5F9] rounded-xl py-2 md:py-3 px-4 md:px-5 border-none text-sm md:text-base"
                          >
                            {ageItems?.map((item) => (
                              <option key={item} value={item}>
                                {item}
                              </option>
                            ))}
                          </select>
                        </div>
                        <div className="text-start flex flex-col gap-1 w-full">
                          <label className="font-semibold text-sm md:text-base">
                            {t("profil.birthdate")}
                          </label>
                          <input
                            type="text"
                            value={dateOfBirth}
                            onClick={toggleDatePicker}
                            readOnly
                            className="bg-[#F4F5F9] border-none rounded-xl py-2 md:py-3 px-4 md:px-5 w-full placeholder-[#A4A4A4] text-sm md:text-base"
                            placeholder="Date de naissance"
                          />
                          {showPicker && (
                            <input
                              type="date"
                              value={date}
                              onChange={(e) =>
                                onChange(
                                  { type: "set" },
                                  new Date(e.target.value)
                                )
                              }
                              className="absolute z-10"
                            />
                          )}
                          {dateOfBirthMessage && (
                            <p className="text-red-500 text-xs md:text-sm">
                              {dateOfBirthMessage}
                            </p>
                          )}
                        </div>
                      </div>
                      <div className="text-start flex flex-col gap-1">
                        <label className="font-semibold text-sm md:text-base">
                          {t("profil.birthdate")}
                        </label>
                        <input
                          type="text"
                          value={club}
                          onChange={(e) => setClub(e.target.value)}
                          className="bg-[#F4F5F9] border-none rounded-xl py-2 md:py-3 px-4 md:px-5 w-full placeholder-[#A4A4A4] text-sm md:text-base"
                          placeholder="Affiliation au club"
                        />
                      </div>
                      <div className="text-start flex flex-col gap-1">
                        <label className="font-semibold text-sm md:text-base">
                          {t("profil.birthdate")}
                        </label>
                        <input
                          type="text"
                          value={license}
                          onChange={(e) => setLicense(e.target.value)}
                          className="bg-[#F4F5F9] border-none rounded-xl py-2 md:py-3 px-4 md:px-5 w-full placeholder-[#A4A4A4] text-sm md:text-base"
                          placeholder="Numéro de licence"
                        />
                      </div>
                      <div className="text-start flex flex-col gap-1">
                        <label className="font-semibold text-sm md:text-base">
                          {t("profil.company")}
                        </label>
                        <input
                          type="text"
                          value={company}
                          onChange={(e) => setCompany(e.target.value)}
                          className="bg-[#F4F5F9] border-none rounded-xl py-2 md:py-3 px-4 md:px-5 w-full placeholder-[#A4A4A4] text-sm md:text-base"
                          placeholder="Entreprise"
                        />
                      </div>
                      <div className="text-start flex flex-col gap-1 mt-3">
                        <div className="font-bold text-xs md:text-[12px]">
                          {t("profil.ensure_full_name")}
                        </div>
                        <label className="font-semibold text-sm md:text-base">
                          {t("profil.recommended_by")}
                        </label>
                        <input
                          type="text"
                          value={referred}
                          onChange={(e) => setReferred(e.target.value)}
                          className="bg-[#F4F5F9] border-none rounded-xl py-2 md:py-3 px-4 md:px-5 w-full placeholder-[#A4A4A4] text-sm md:text-base"
                          placeholder="Recommandé par"
                        />
                      </div>
                    </div>
                    {/* the left section */}
                    <div className="flex flex-col gap-3">
                      <div className="text-start flex flex-col gap-1">
                        <label className="font-semibold text-sm md:text-base">
                          {t("profil.email")}
                        </label>
                        <input
                          type="email"
                          value={email}
                          onChange={(e) => setEmail(e.target.value)}
                          className="bg-[#F4F5F9] border-none rounded-xl py-2 md:py-3 px-4 md:px-5 w-full placeholder-[#A4A4A4] text-sm md:text-base"
                          placeholder="Email"
                        />
                        {emailMessage && (
                          <p className="text-red-500 text-xs md:text-sm">
                            {emailMessage}
                          </p>
                        )}
                      </div>
                      <div className="text-start flex flex-col gap-1">
                        <label className="font-semibold text-sm md:text-base">
                          {t("profil.confirm_password")}
                        </label>
                        <input
                          type={hidePass ? "password" : "text"}
                          value={password}
                          onChange={(e) => setPassword(e.target.value)}
                          className="bg-[#F4F5F9] border-none rounded-xl py-2 md:py-3 px-4 md:px-5 w-full placeholder-[#A4A4A4] text-sm md:text-base"
                          placeholder="Confirmer le Mot de passe"
                        />
                        {passwordMessage && (
                          <p className="text-red-500 text-xs md:text-sm">
                            {passwordMessage}
                          </p>
                        )}
                      </div>
                      <div className="text-start flex flex-col gap-1">
                        <label className="font-semibold text-sm md:text-base">
                          Pays
                        </label>
                        <input
                          type="text"
                          value={country}
                          onChange={(e) => setCountry(e.target.value)}
                          className="bg-[#F4F5F9] border-none rounded-xl py-2 md:py-3 px-4 md:px-5 w-full placeholder-[#A4A4A4] text-sm md:text-base"
                          placeholder="Pays"
                        />
                      </div>
                      <div className="text-start flex flex-col gap-1">
                        <label className="font-semibold text-sm md:text-base">
                          {t("profil.phone")}
                        </label>
                        <input
                          type="text"
                          value={phoneNumber}
                          onChange={(e) => setPhoneNumber(e.target.value)}
                          className="bg-[#F4F5F9] border-none rounded-xl py-2 md:py-3 px-4 md:px-5 w-full placeholder-[#A4A4A4] text-sm md:text-base"
                          placeholder="Numéro de téléphone"
                        />
                        {phoneMessage && (
                          <p className="text-red-500 text-xs md:text-sm">
                            {phoneMessage}
                          </p>
                        )}
                      </div>
                      <div className="text-start flex flex-col gap-1">
                        <label className="font-semibold text-sm md:text-base">
                          {t("profil.golfer")}?
                        </label>
                        <select
                          value={golfer}
                          onChange={(e) => setGolfer(e.target.value)}
                          required
                          className="w-full text-gray-400 focus:text-black bg-[#F4F5F9] rounded-xl py-2 md:py-3 px-4 md:px-5 border-none text-sm md:text-base"
                        >
                          {Golfer?.map((item) => (
                            <option key={item} value={item}>
                              {item}
                            </option>
                          ))}
                        </select>
                      </div>
                      <div className="text-start flex flex-col gap-1">
                        <label className="font-semibold text-sm md:text-base">
                          {t("profil.handicap")}
                        </label>
                        <select
                          value={handicap || ""}
                          onChange={(e) => setHandicap(e.target.value)}
                          required
                          className="w-full text-gray-400 focus:text-black bg-[#F4F5F9] rounded-xl py-2 md:py-3 px-4 md:px-5 border-none text-sm md:text-base"
                        >
                          {handicapItems?.map((item) => (
                            <option key={item} value={item}>
                              {item}
                            </option>
                          ))}
                        </select>
                      </div>
                      <div className="text-start flex flex-col gap-1">
                        <label className="font-semibold text-sm md:text-base">
                          {t("profil.activity_sector")}
                        </label>
                        <select
                          value={sector || ""}
                          onChange={(e) => setSector(e.target.value)}
                          required
                          className="w-full text-gray-400 focus:text-black bg-[#F4F5F9] rounded-xl py-2 md:py-3 px-4 md:px-5 border-none text-sm md:text-base"
                        >
                          {sectorItems?.map((item) => (
                            <option key={item} value={item}>
                              {item}
                            </option>
                          ))}
                        </select>
                        {sector === "Other" && (
                          <div>
                            <input
                              type="text"
                              value={specify}
                              onChange={(e) => setSpecify(e.target.value)}
                              className="bg-[#F4F5F9] border-none rounded-xl py-2 md:py-3 px-4 md:px-5 w-full mt-2 text-sm md:text-base"
                              placeholder="Specify your industry"
                            />
                            {specifyMessage && (
                              <p className="text-red-500 text-xs md:text-sm">
                                {specifyMessage}
                              </p>
                            )}
                          </div>
                        )}
                      </div>
                      <div className="text-start flex flex-col gap-1">
                        <label className="font-semibold text-sm md:text-base">
                          {t("profil.position")}
                        </label>
                        <input
                          type="text"
                          value={position}
                          onChange={(e) => setPosition(e.target.value)}
                          className="bg-[#F4F5F9] border-none rounded-xl py-2 md:py-3 px-4 md:px-5 w-full placeholder-[#A4A4A4] text-sm md:text-base"
                          placeholder="Poste"
                        />
                      </div>
                    </div>
                  </div>

                  <button
                    type="submit"
                    onClick={update}
                    disabled={
                      !emailValidated || (password ? !passwordValidated : false)
                    }
                    className={`w-full max-w-[350px] py-2 md:py-3 text-sm md:text-base rounded-[33px] font-semibold mx-auto block 
                  ${
                    !emailValidated || (password ? !passwordValidated : false)
                      ? "bg-gray-300 text-gray-600 cursor-not-allowed"
                      : "bg-black text-white"
                  }
                `}
                  >
                    Update
                  </button>

                  <button
                    onClick={deleteUser}
                    className={`w-full max-w-[350px] bg-red-600 text-white py-2 md:py-3 text-sm md:text-base rounded-[33px] font-semibold border-none mx-auto block`}
                  >
                    {t("profil.supp")}
                  </button>
                </div>
              </div>
            )}
          </div>
       
  );

  // return (
  //   <div
  //     className="flex flex-col gap-12 min-h-screen"
  //     style={{
  //       backgroundImage: `url(${images.golf_field})`,
  //       backgroundPosition: "center",
  //       backgroundSize: "cover",
  //       backgroundRepeat: "no-repeat",
  //       backgroundAttachment: "fixed"
  //     }}
  //   >
  //     <Nav />
  //     <div className="flex justify-center mx-16 mb-20">
  //       <div className="flex w-full h-full justify-between items-start ">
  //         <Sidebar />
  //         <div className="bg-white bg-opacity-[87%] flex flex-col justify-center items-center p-16 gap-8 w-[75%] rounded-3xl py-16">
  //           <div className="text-center text-6xl font-bold mb-3">
  //             <p>MY PROFIL</p>
  //           </div>
  //           <div className="bg-white text-center p-16 rounded-3xl w-full h-full flex flex-col gap-12 ">
  //             <div className="flex flex-col items-center justify-center">
  //               {/* Image upload section */}
  //               {updatingImage ? (
  //                 <div className="flex justify-center items-center h-[135px] w-[135px] rounded-full bg-gray-200">
  //                   <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-gray-900"></div>
  //                 </div>
  //               ) : (
  //                 <>
  //                   <input
  //                     id="profileInput"
  //                     type="file"
  //                     accept="image/*"
  //                     className="hidden"
  //                     onChange={pickImage}
  //                   />
  //                   <div
  //                     className="relative cursor-pointer"
  //                     onClick={triggerFileInput}
  //                   >
  //                     <img
  //                       src={imagess}
  //                       alt="Profile"
  //                       className="h-[140px]  w-[235px]"
  //                     />
  //                     <img
  //                       src={picturePreview || user?.photo}
  //                       alt="Profile"
  //                       className="h-[135px] w-[135px] rounded-full absolute bottom-[5px] left-1/2 transform -translate-x-1/2"
  //                     />
  //                   </div>
  //                 </>
  //               )}

  //               {/* Update/Edit button */}
  //               {IsPicked ? (
  //                 <button
  //                 onClick={() => {
  //                   updateImage();
  //                   // window.location.reload();
  //                 }}
  //                   className="text-white mt-3 mb-2   font-bold px-8 py-2 rounded-full  text-base cursor-pointer"
  //                   style={{
  //                     background: getGradientStyle(
  //                       membership?.membership_packs?.name?.toLowerCase()
  //                     ),
  //                   }}
  //                 >
  //                   Update your photo
  //                 </button>
  //               ) : (
  //                 <button
  //                   onClick={() => {
  //                     if (user && user.id) {
  //                       console.log("User is fetched:", user);
  //                       triggerFileInput();
  //                     } else {
  //                       console.log("User is not loaded yet.");
  //                       setUploadErr("Please wait for user data to load.");
  //                     }
  //                   }}
  //                   className="text-blue-600 mt-1 font-bold px-8 py-2  text-base cursor-pointer"
  //                 >
  //                   Edit
  //                 </button>
  //               )}

  //               {/* Error message */}
  //               {uploadErr && (
  //                 <div className="text-red-500 text-sm mt-1">{uploadErr}</div>
  //               )}

  //               {/* Member status */}
  //               {pack && (
  //                 <div className="mt-2 mb-1">
  //                   <span
  //                     className="font-bold"
  //                     style={{ color: pack?.color || "#000" }}
  //                   >
  //                     {pack?.name?.charAt(0).toUpperCase() +
  //                       pack?.name?.slice(1)}
  //                   </span>{" "}
  //                   Member
  //                 </div>
  //               )}

  //               {/* Upgrade option */}
  //               {pack?.id !== 3 && (
  //                 <button
  //                   onClick={() => navigate("/membership/demande")}
  //                   className="text-white bg-[#608D40] font-bold px-8 py-3 rounded-full"
  //                 >
  //                   Upgrade
  //                 </button>
  //               )}
  //             </div>
  //             <div className="grid gap-5 grid-cols-2">
  //               {/* the right section */}
  //               <div className="flex flex-col gap-3">
  //                 <div className="flex gap-4 ">
  //                   <div className="text-start flex flex-col gap-1">
  //                     <label className="font-semibold">Prénom</label>
  //                     <input
  //                       type="text"
  //                       value={fname}
  //                       onChange={(e) => setFname(e.target.value)}
  //                       className="bg-[#F4F5F9] border-none rounded-xl py-3 px-5  w-full max-w-full sm:max-w-[500px] mx-auto block placeholder-[#A4A4A4]"
  //                       placeholder="Prénom"
  //                     />
  //                   </div>
  //                   <div className="text-start flex flex-col gap-1">
  //                     <label className="font-semibold">Nom de famille</label>
  //                     <input
  //                       type="text"
  //                       value={lname}
  //                       onChange={(e) => setLname(e.target.value)}
  //                       className="bg-[#F4F5F9] border-none rounded-xl py-3 px-5  w-full max-w-full sm:max-w-[500px] mx-auto block placeholder-[#A4A4A4]"
  //                       placeholder="Nom de famille"
  //                     />
  //                   </div>
  //                 </div>
  //                 <div className="text-start flex flex-col gap-1">
  //                   <label className="font-semibold">Mot de passe </label>
  //                   <input
  //                     type={hidePass ? "password" : "text"}
  //                     value={password}
  //                     onChange={(e) => setPassword(e.target.value)}
  //                     className="bg-[#F4F5F9] border-none rounded-xl py-3 px-5  w-full max-w-full sm:max-w-[500px] mx-auto block placeholder-[#A4A4A4]"
  //                     placeholder="Mot de passe"
  //                   />
  //                 </div>
  //                 <div className="text-start flex flex-col gap-1">
  //                   <label className="font-semibold">Sexe ex: Homme</label>
  //                   <input
  //                     type="text"
  //                     value={sex}
  //                     onChange={(e) => setSex(e.target.value)}
  //                     className="bg-[#F4F5F9] border-none rounded-xl py-3 px-5  w-full max-w-full sm:max-w-[500px] mx-auto block placeholder-[#A4A4A4]"
  //                     placeholder="Sexe ex: Homme"
  //                   />
  //                 </div>
  //                 <div className="text-start flex flex-col gap-1">
  //                   <label className="font-semibold">Ville</label>
  //                   <select
  //                     value={city}
  //                     onChange={(e) => setCity(e.target.value)}
  //                     required
  //                     className="w-full text-gray-400 focus:text-black bg-[#F4F5F9]  rounded-xl py-3 px-5 border-none"
  //                   >
  //                     {moroccanCities?.map((item) => (
  //                       <option key={item} value={item}>
  //                         {item}
  //                       </option>
  //                     ))}
  //                   </select>
  //                 </div>
  //                 <div className="flex gap-4">
  //                   <div className="text-start flex flex-col gap-1">
  //                     <label className="font-semibold">Age</label>
  //                     <select
  //                       value={age}
  //                       onChange={(e) => setAge(e.target.value)}
  //                       required
  //                       className="w-full text-gray-400 focus:text-black bg-[#F4F5F9]  rounded-xl py-3 px-5 border-none"
  //                     >
  //                       {ageItems?.map((item) => (
  //                         <option key={item} value={item}>
  //                           {item}
  //                         </option>
  //                       ))}
  //                     </select>
  //                   </div>
  //                   <div className="text-start flex flex-col gap-1">
  //                     <label className="font-semibold">Date de naissance</label>
  //                     <input
  //                       type="text"
  //                       value={dateOfBirth}
  //                       onClick={toggleDatePicker}
  //                       readOnly
  //                       className="bg-[#F4F5F9] border-none rounded-xl py-3 px-5  w-full max-w-full sm:max-w-[500px] mx-auto block placeholder-[#A4A4A4]"
  //                       placeholder="Date de naissance"
  //                     />
  //                     {showPicker && (
  //                       <input
  //                         type="date"
  //                         value={date}
  //                         onChange={(e) =>
  //                           onChange({ type: "set" }, new Date(e.target.value))
  //                         }
  //                         className="absolute z-10"
  //                       />
  //                     )}
  //                     {dateOfBirthMessage && (
  //                       <p className="text-red-500 text-sm">
  //                         {dateOfBirthMessage}
  //                       </p>
  //                     )}
  //                   </div>
  //                 </div>
  //                 <div className="text-start flex flex-col gap-1">
  //                   <label className="font-semibold">Affiliation au club</label>
  //                   <input
  //                     type="text"
  //                     value={club}
  //                     onChange={(e) => setClub(e.target.value)}
  //                     className="bg-[#F4F5F9] border-none rounded-xl py-3 px-5  w-full max-w-full sm:max-w-[500px] mx-auto block placeholder-[#A4A4A4]"
  //                     placeholder="Affiliation au club"
  //                   />
  //                 </div>
  //                 <div className="text-start flex flex-col gap-1">
  //                   <label className="font-semibold">Numéro de licence</label>
  //                   <input
  //                     type="text"
  //                     value={license}
  //                     onChange={(e) => setLicense(e.target.value)}
  //                     className="bg-[#F4F5F9] border-none rounded-xl py-3 px-5  w-full max-w-full sm:max-w-[500px] mx-auto block placeholder-[#A4A4A4]"
  //                     placeholder="Numéro de licence"
  //                   />
  //                 </div>
  //                 <div className="text-start flex flex-col gap-1">
  //                   <label className="font-semibold">Entreprise</label>
  //                   <input
  //                     type="text"
  //                     value={company}
  //                     onChange={(e) => setCompany(e.target.value)}
  //                     className="bg-[#F4F5F9] border-none rounded-xl py-3 px-5  w-full max-w-full sm:max-w-[500px] mx-auto block placeholder-[#A4A4A4]"
  //                     placeholder="Entreprise"
  //                   />
  //                 </div>
  //                 <div className="text-start flex flex-col gap-1 mt-3">
  //                   <div className="font-bold text-[12px]">
  //                     Assurez-vous de saisir le nom complet correctement.
  //                   </div>
  //                   <label className="font-semibold">Recommandé par</label>
  //                   <input
  //                     type="text"
  //                     value={referred}
  //                     onChange={(e) => setReferred(e.target.value)}
  //                     className="bg-[#F4F5F9] border-none rounded-xl py-3 px-5  w-full max-w-full sm:max-w-[500px] mx-auto block placeholder-[#A4A4A4]"
  //                     placeholder="Recommandé par"
  //                   />
  //                 </div>
  //               </div>
  //               {/* the left section */}
  //               <div className="flex flex-col gap-3">
  //                 <div className="text-start flex flex-col gap-1">
  //                   <label className="font-semibold">Email</label>
  //                   <input
  //                     type="email"
  //                     value={email}
  //                     onChange={(e) => setEmail(e.target.value)}
  //                     className="bg-[#F4F5F9] border-none rounded-xl py-3 px-5  w-full max-w-full sm:max-w-[500px] mx-auto block placeholder-[#A4A4A4]"
  //                     placeholder="Email"
  //                   />
  //                   {emailMessage && (
  //                     <p className="text-red-500 text-sm">{emailMessage}</p>
  //                   )}
  //                 </div>
  //                 <div className="text-start flex flex-col gap-1">
  //                   <label className="font-semibold">
  //                     Confirmer le Mot de passe
  //                   </label>
  //                   <input
  //                     type={hidePass ? "password" : "text"}
  //                     value={password}
  //                     onChange={(e) => setPassword(e.target.value)}
  //                     className="bg-[#F4F5F9] border-none rounded-xl py-3 px-5  w-full max-w-full sm:max-w-[500px] mx-auto block placeholder-[#A4A4A4]"
  //                     placeholder="Confirmer le Mot de passe"
  //                   />
  //                   {passwordMessage && (
  //                     <p className="text-red-500 text-sm">{passwordMessage}</p>
  //                   )}
  //                 </div>
  //                 <div className="text-start flex flex-col gap-1">
  //                   <label className="font-semibold">Pays</label>
  //                   <input
  //                     type="text"
  //                     value={country}
  //                     onChange={(e) => setCountry(e.target.value)}
  //                     className="bg-[#F4F5F9] border-none rounded-xl py-3 px-5  w-full max-w-full sm:max-w-[500px] mx-auto block placeholder-[#A4A4A4]"
  //                     placeholder="Pays"
  //                   />
  //                 </div>
  //                 <div className="text-start flex flex-col gap-1">
  //                   <label className="font-semibold">Numéro de téléphone</label>
  //                   <input
  //                     type="text"
  //                     value={phoneNumber}
  //                     onChange={(e) => setPhoneNumber(e.target.value)}
  //                     className="bg-[#F4F5F9] border-none rounded-xl py-3 px-5  w-full max-w-full sm:max-w-[500px] mx-auto block placeholder-[#A4A4A4]"
  //                     placeholder="Numéro de téléphone"
  //                   />
  //                   {phoneMessage && (
  //                     <p className="text-red-500 text-sm">{phoneMessage}</p>
  //                   )}
  //                 </div>
  //                 <div className="text-start flex flex-col gap-1">
  //                   <label className="font-semibold">Golfeur?</label>
  //                   <select
  //                     value={golfer}
  //                     onChange={(e) => setGolfer(e.target.value)}
  //                     required
  //                     className="w-full text-gray-400 focus:text-black bg-[#F4F5F9]  rounded-xl py-3 px-5 border-none"
  //                   >
  //                     {Golfer?.map((item) => (
  //                       <option key={item} value={item}>
  //                         {item}
  //                       </option>
  //                     ))}
  //                   </select>
  //                 </div>
  //                 <div className="text-start flex flex-col gap-1">
  //                   <label className="font-semibold">Handicap</label>
  //                   <select
  //                     value={handicap || ""}
  //                     onChange={(e) => setHandicap(e.target.value)}
  //                     required
  //                     className="w-full text-gray-400 focus:text-black  bg-[#F4F5F9] rounded-xl py-3 px-5 border-none focus:ring-0"
  //                   >
  //                     {handicapItems?.map((item) => (
  //                       <option key={item} value={item}>
  //                         {item}
  //                       </option>
  //                     ))}
  //                   </select>
  //                 </div>
  //                 <div className="text-start flex flex-col gap-1">
  //                   <label className="font-semibold">Secteur d'activité</label>
  //                   <select
  //                     value={sector || ""}
  //                     onChange={(e) => setSector(e.target.value)}
  //                     required
  //                     className="w-full text-gray-400 focus:text-black  bg-[#F4F5F9] rounded-xl py-3 px-5 border-none focus:ring-0"
  //                   >
  //                     {sectorItems?.map((item) => (
  //                       <option key={item} value={item}>
  //                         {item}
  //                       </option>
  //                     ))}
  //                   </select>
  //                   {sector === "Other" && (
  //                     <div>
  //                       <input
  //                         type="text"
  //                         value={specify}
  //                         onChange={(e) => setSpecify(e.target.value)}
  //                         className="bg-[#F4F5F9] border-none rounded-xl py-3 px-5 w-full mt-2"
  //                         placeholder="Specify your industry"
  //                       />
  //                       {specifyMessage && (
  //                         <p className="text-red-500 text-sm">
  //                           {specifyMessage}
  //                         </p>
  //                       )}
  //                     </div>
  //                   )}
  //                 </div>
  //                 <div className="text-start flex flex-col gap-1">
  //                   <label className="font-semibold">Poste</label>
  //                   <input
  //                     type="text"
  //                     value={position}
  //                     onChange={(e) => setPosition(e.target.value)}
  //                     className="bg-[#F4F5F9] border-none rounded-xl py-3 px-5  w-full max-w-full sm:max-w-[500px] mx-auto block placeholder-[#A4A4A4]"
  //                     placeholder="Poste"
  //                   />
  //                 </div>
  //               </div>
  //             </div>

  //             <button
  //               type="submit"
  //               onClick={update}
  //               disabled={
  //                 !emailValidated || (password ? !passwordValidated : false)
  //               }
  //               className={`w-full sm:max-w-[350px] py-3 text-base rounded-[33px] font-semibold mx-auto block
  //   ${
  //     !emailValidated || (password ? !passwordValidated : false)
  //       ? "bg-gray-300 text-gray-600 cursor-not-allowed"
  //       : "bg-black text-white"
  //   }
  // `}
  //             >
  //               update
  //             </button>

  //             <button
  //               onClick={deleteUser}
  //               fullWidth
  //               sx={{ maxWidth: "200px" }}
  //               className={`w-full bg-red-600 text-white sm:max-w-[350px] py-3 text-base rounded-[33px] font-semibold border-none mx-auto block `}
  //             >
  //               Supprimer
  //             </button>
  //           </div>
  //         </div>
  //       </div>
  //     </div>
  //   </div>
  // );
}
